export const archiveButtonLoading = state => !state.areArchivesLoaded && state.areArchivesLoading

export const archiveButtonText = (state, getters) =>
  (state.areArchivesOpen && !getters.archiveButtonLoading) ? 'Fermer les archives' : 'Archives'
